// extracted by mini-css-extract-plugin
export default {"container":"HF4Rdg","title":"JUUlRW","root":"lAV8vv"};